<su-headline h="h1" skin="primary">{{
  'taskmodule.task.update.title' | translate
}}</su-headline>

<su-slot-tabs [tabs]="tabs" [activeTab]="activeTab"></su-slot-tabs>

<su-slot-tab-content *ngIf="activeTab === tabs[0].id">
  <div
    class="task-card-shell"
    [class.task-card-shell--wide]="isWideLayout"
    data-mode="light">
    <div class="top-button-container" *ngIf="isOPLExt">
      <su-button
        *ngIf="canShowAddPurchaseResultsButton"
        skin="primary"
        [label]="'taskmodule.task.purchase.add_results' | translate"
        (onClick)="activateEditFields()"
        [tooltip]="'taskmodule.task.purchase.tooltip.add_results' | translate"
        [disabled]="isTask2LineItemsEditable">
      </su-button>
      <su-button
        *ngIf="canShowOrderedAddendumQuotationButton"
        skin="primary"
        [label]="
          'taskmodule.task.offer.ordered_addendum_offer.button_label'
            | translate
        "
        (onClick)="showOrderedAddendumQuotation()"
        [tooltip]="
          'taskmodule.task.offer.tooltip.ordered_addendum_offer' | translate">
      </su-button>
      <su-button
        *ngIf="isTask7ExecuteOptionalService"
        skin="primary"
        [label]="'taskmodule.task.offer.ordered_offer.button_label' | translate"
        (onClick)="showOrderedQuotation()"
        [tooltip]="'taskmodule.task.offer.tooltip.ordered_offer' | translate">
      </su-button>
      <su-button
        skin="secondary"
        icon="file-excel"
        [label]="'Excel Download'"
        (onClick)="exportToExcel()"
        [disabled]="!canDownload"
        tooltip="{{
          'taskmodule.task.button.tooltip.excel_export' | translate
        }}">
      </su-button>
    </div>

    <su-card [card]="cardFields">
      <div card-content>
        <div class="card-action-row" *ngIf="isOPLExt">
          <span
            *ngIf="isTask2_3_7_11 && taskSubjectHeadline"
            class="task-subject-headline">
            {{ taskSubjectHeadline }}
          </span>

          <div class="card-action-controls">
            <su-button
              skin="secondary"
              icon="arrows-left-right"
              [matTooltip]="buttonMaxWidthTitle"
              [ariaLabel]="buttonMaxWidthTitle"
              (onClick)="toggleWideLayout()"></su-button>
          </div>
        </div>

        <!-- <excel-export-telekom [formModel]="formModel" [isLoading]="isLoading" [formFields]="formFields"></excel-export-telekom> -->
        <formly-form
          *ngIf="!isLoading"
          [form]="form"
          [fields]="formFields"
          [model]="formModel"
          (modelChange)="modelOnChange()"></formly-form>
        <div class="button-container">
          <su-button
            *ngIf="formModel.subject === '12.1 Mietinteressent melden'"
            [label]="'taskmodule.task.prospective_tenants.record' | translate"
            [disabled]="false"
            (onClick)="recordProspectiveTenants()"
            skin="secondary"
            class="button-left"></su-button>
          <su-button
            [label]="'shared.save' | translate"
            [tooltip]="saveButtonTooltip"
            [disabled]="
              !this.form.valid ||
              this.isLoading ||
              this.isEquipmentDocumentationUploading ||
              !this.form.touched ||
              !this.isSaveButtonEnabled
            "
            (onClick)="submit()"
            class="button-right"></su-button>
        </div>

        <ng-container *ngIf="isTask11SubmitInvoiceToScanCenter">
          <formly-information-row />
        </ng-container>

        <ng-container
          *ngIf="
            dataProspectiveTenantsList$ | async as dataProspectiveTenantsList
          ">
          <h3 *ngIf="dataProspectiveTenantsList.length > 0">
            {{ 'taskmodule.task.prospective_tenants.label' | translate }}
          </h3>
          <br />
          <table
            *ngIf="dataProspectiveTenantsList.length > 0"
            mat-table
            [dataSource]="dataProspectiveTenantsList"
            class="mat-elevation-z8">
            <ng-container matColumnDef="ticketNumber">
              <th mat-header-cell *matHeaderCellDef>
                {{
                  'taskmodule.task.prospective_tenants.ticketnumber' | translate
                }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ticketNumber }}
              </td>
            </ng-container>

            <ng-container matColumnDef="requestedArea">
              <th mat-header-cell *matHeaderCellDef>
                {{
                  'taskmodule.task.prospective_tenants.requested_area'
                    | translate
                }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.requestedArea }}
              </td>
            </ng-container>

            <ng-container matColumnDef="requestedParkingSpace">
              <th mat-header-cell *matHeaderCellDef>
                {{
                  'taskmodule.task.prospective_tenants.requested_parking_spaces'
                    | translate
                }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.requestedParkingSpace }}
              </td>
            </ng-container>

            <ng-container matColumnDef="ticketStatusReason">
              <th mat-header-cell *matHeaderCellDef>
                {{
                  'taskmodule.task.prospective_tenants.ticketStatusReason'
                    | translate
                }}
              </th>
              <td mat-cell *matCellDef="let element">
                {{ element.ticketStatusReason }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
        </ng-container>
      </div>
    </su-card>
  </div>
</su-slot-tab-content>

<su-slot-tab-content *ngIf="activeTab === tabs[1].id">
  <su-headline h="h1" skin="primary">{{
    'taskmodule.task.update.filesTitle' | translate
  }}</su-headline>

  <su-card [card]="cardDocumentupload">
    <div card-content>
      <app-detail-fields-base
        *ngIf="task"
        [data]="task"
        [detailFields]="detailFields"
        [allowFileUpload]="!isTask11SubmitInvoiceToScanCenter"
        [allowedFileExtensions]="
          hasTask3And7UploadRestrictions ? task3And7AllowedFileExtensions : []
        "
        [maxUploadFiles]="hasTask3And7UploadRestrictions ? 10 : null"
        [tooltipSelectDocument]="tooltipSelectDocument"
        [tooltipUploadDocument]="
          tooltipUploadDocument
        "></app-detail-fields-base>
    </div>
  </su-card>
</su-slot-tab-content>

<su-slot-tab-content *ngIf="activeTab === tabs[2].id">
  <su-card [card]="cardContact">
    <div card-content>
      <app-task-contact
        *ngIf="task"
        [isOPLExt]="isOPLExt"
        [dataContactAddress]="task.incident"></app-task-contact>
    </div>
  </su-card>
</su-slot-tab-content>

<su-slot-tab-content *ngIf="activeTab === tabs[3]?.id">
  <div [style]="descriptionContainerStyle">
    <div
      class="sub-headline contactDescription"
      [style]="descriptionStyle"
      [innerHtml]="description | safeHtml"></div>
  </div>
  <su-card [card]="cardContactUs">
    <div card-content>
      <form [formGroup]="formContactUs">
        <formly-form
          [form]="formContactUs"
          [fields]="formFieldsContactUs"
          [model]="formModelContactUs"></formly-form>
        <app-spinner-overlay
          [show]="isLoading || isEquipmentDocumentationUploading"
          [label]="
            'ticket.summary.contact.loading_message' | translate
          "></app-spinner-overlay>
      </form>
    </div>
  </su-card>
</su-slot-tab-content>

<app-spinner-overlay
  [show]="isLoading || isEquipmentDocumentationUploading"></app-spinner-overlay>
